<template>
  <v-dialog v-model="value" persistent>
    <!-- @input="$emit('input', $event.target.value)" -->
    <v-stepper v-model="stepper" alt-labels>
      <v-stepper-header>
        <v-stepper-step :complete="stepper > 1" step="1">
          Elegir Acciones
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="stepper > 2" step="2">
          Elegir parte
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="stepper > 1 && isValid && parteSeleccionado.length !== 0 && !loading"
          :rules="[() => isValid]"
          step="3"
        >
          Validar contratos
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="4"> Resumen </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card>
            <v-data-table
              :headers="headerAcciones"
              :items="acciones"
              :search="buscarAcciones"
              multi-sort
              show-select
              v-model="accionesSeleccionadas"
            >
              <!-- Buscador -->
              <template v-slot:top>
                <v-toolbar flat>
                  <v-text-field
                    v-model="buscarAcciones"
                    append-icon="mdi-file-search-outline"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-toolbar>
              </template>

              <!-- Técnico -->
              <template v-slot:item.user.name="{ item }">
                <v-chip outlined>
                  <v-avatar left :color="item.user.color">
                    <span class="white--text">
                      {{ item.user.avatar }}
                    </span>
                  </v-avatar>
                  {{ item.user.name }}
                </v-chip>
              </template>

              <!-- Fecha -->
              <template v-slot:item.fecha="{ item }">
                {{ formatDate(item.fecha) }}
              </template>

              <!-- Comentarios -->
              <template v-slot:item.comentarios="{ item }">
                <v-textarea
                  v-model="item.comentarios"
                  readonly
                  hide-details
                  rows="1"
                ></v-textarea>
              </template>

              <!-- Desplazamiento -->
              <template v-slot:item.desplazamiento="{ item }">
                <v-checkbox v-model="item.desplazamiento" disabled></v-checkbox>
              </template>

              <!-- Fura horas -->
              <template v-slot:item.fuera_horas="{ item }">
                <v-checkbox v-model="item.fuera_horas" disabled></v-checkbox>
              </template>

              <!-- Asistencia minia -->
              <template v-slot:item.asistencia_minima="{ item }">
                <v-checkbox
                  v-model="item.asistencia_minima"
                  disabled
                ></v-checkbox>
              </template>

              <!-- Abono -->
              <template v-slot:item.abono="{ item }">
                <v-checkbox v-model="item.abono" disabled></v-checkbox>
              </template>

              <!-- APV -->
              <template v-slot:item.apv="{ item }">
                <v-checkbox v-model="item.apv" disabled></v-checkbox>
              </template>
            </v-data-table>
          </v-card>
          <v-btn color="red" text @click="cerrar()">Cerrar</v-btn>
          <v-btn
            color="green"
            text
            @click="incrementarStepper()"
            @keydown.ctrl="ctrl = true"
            :disabled="accionesSeleccionadas.length === 0"
            >Siguiente</v-btn
          >
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card>
            <v-data-table
              :headers="headersPartes"
              :items="partesDisponibles.filter((item) => item.id !== parteId)"
              :search="buscarPartes"
              multi-sort
              show-select
              single-select
              v-model="parteSeleccionado"
              :loading="loadingPartes"
              @item-selected="validarContratos($event)"
              sort-by="fecha"
              sort-desc
            >
              <!-- Buscador -->
              <template v-slot:top>
                <v-row>
                  <v-col cols="12" align="end">
                    <NuevoParte
                      :clientes="clientes"
                      :usuarios="usuarios"
                      @actualizarPartes="cargarPartes(true)"
                    ></NuevoParte>
                  </v-col>
                </v-row>
                <v-toolbar flat>
                  <v-text-field
                    v-model="buscarPartes"
                    append-icon="mdi-file-search-outline"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-toolbar>
              </template>

              <!-- Técnico -->
              <template v-slot:item.user.name="{ item }">
                <v-chip outlined>
                  <v-avatar left :color="item.user.color">
                    <span class="white--text">
                      {{ item.user.avatar }}
                    </span>
                  </v-avatar>
                  {{ item.user.name }}
                </v-chip>
              </template>

              <!-- Fecha vto -->
              <template v-slot:item.fechaVto="{ item }">
                {{ formatDate(item.fechaVto) }}
              </template>

              <!-- Estado del parte -->
              <template v-slot:item.estado_parte="{ item }">
                <v-chip :color="item.estado_parte.color" outlined pill small>
                  {{ item.estado_parte.estado }}
                </v-chip>
              </template>
            </v-data-table>

          </v-card>
          <v-btn color="red" text @click="cerrar()">Cancelar</v-btn>
          <v-btn color="blue" text @click.stop="decrementarStepper()"
            >Volver</v-btn
          >
          <v-btn
            color="green"
            text
            @click="incrementarStepper()"
            :loading="loadingPartes"
            :disabled="!parteSeleccionado.length"
            >Siguiente</v-btn
          >
        </v-stepper-content>

        <v-stepper-content step="3">
          <ValidaContratosAcciones></ValidaContratosAcciones>
          <v-btn color="red" text @click="cerrar()">Cancelar</v-btn>
          <v-btn color="blue" text @click.stop="decrementarStepper()"
            >Volver</v-btn
          >
          <v-btn
            color="green"
            text
            @click="incrementarStepper()"
            :disabled="!isValid"
            >Siguiente</v-btn
          >
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-card class="mb-4">
            <v-card-title> Vas a mover las siguientes acciones: </v-card-title>
            <v-card-text>
              <v-data-table :headers="headerAcciones" :items="resumenAcciones">
                
                <!-- Técnico -->
                <template v-slot:item.user.name="{ item }">
                  <v-chip outlined>
                    <v-avatar left :color="item.user.color">
                      <span class="white--text">
                        {{ item.user.avatar }}
                      </span>
                    </v-avatar>
                    {{ item.user.name }}
                  </v-chip>
                </template>

                <!-- Fecha -->
                <template v-slot:item.fecha="{ item }">
                  {{ formatDate(item.fecha) }}
                </template>

                <!-- Comentarios -->
                <template v-slot:item.comentarios="{ item }">
                  <v-textarea
                    v-model="item.comentarios"
                    readonly
                    hide-details
                    rows="1"
                  ></v-textarea>
                </template>

                <!-- Desplazamiento -->
                <template v-slot:item.desplazamiento="{ item }">
                  <v-checkbox
                    v-model="item.desplazamiento"
                    disabled
                  ></v-checkbox>
                </template>

                <!-- Fura horas -->
                <template v-slot:item.fuera_horas="{ item }">
                  <v-checkbox v-model="item.fuera_horas" disabled></v-checkbox>
                </template>

                <!-- Asistencia minia -->
                <template v-slot:item.asistencia_minima="{ item }">
                  <v-checkbox
                    v-model="item.asistencia_minima"
                    disabled
                  ></v-checkbox>
                </template>

                <!-- Abono -->
                <template v-slot:item.abono="{ item }">
                  <v-checkbox v-model="item.abono" disabled></v-checkbox>
                </template>

                <!-- APV -->
                <template v-slot:item.apv="{ item }">
                  <v-checkbox v-model="item.apv" disabled></v-checkbox>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <v-card>
            <v-card-title> Al siguiente parte: </v-card-title>
            <v-card-text>
              <v-data-table :headers="headersPartes" :items="parteSeleccionado">
                
                <!-- Técnico -->
                <template v-slot:item.user.name="{ item }">
                  <v-chip outlined>
                    <v-avatar left :color="item.user.color">
                      <span class="white--text">
                        {{ item.user.avatar }}
                      </span>
                    </v-avatar>
                    {{ item.user.name }}
                  </v-chip>
                </template>

                <!-- Estado del parte -->
                <template v-slot:item.estado_parte="{ item }">
                  <v-chip :color="item.estado_parte.color" outlined pill small>
                    {{ item.estado_parte.estado }}
                  </v-chip>
                </template>
                
                <!-- Fecha vto -->
                <template v-slot:item.fechaVto="{ item }">
                  {{ formatDate(item.fechaVto) }}
                </template>

              </v-data-table>
            </v-card-text>
          </v-card>

          <v-btn color="red" text @click="cerrar()">Cancelar</v-btn>
          <v-btn color="blue" text @click.stop="decrementarStepper()"
            >Volver</v-btn
          >
          <v-btn
            color="green"
            text
            @click="confirmar()"
            :disabled="resumenAcciones.length === 0"
            :loading="loadingConfirmar"
            >Confirmar</v-btn
          >
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import formatearFecha from "../../mixins/formatearFecha";
import axios from "axios";
import NuevoParte from "./NuevoParte";
import ValidaContratosAcciones from "./ValidaContratosAcciones";
export default {
  // FALTARAN LAS RULES Y COMPLETE CON EL "VALIDO" DE ALEX EN HEADER 3
  // FALTA QUE AL PULSAR SIGUIENTE EN EL STEP 2 SI ESTÁ TODO OK; SALTE AL 4
  //            esto son las funciones todoPreparado y valido
  mixins: [formatearFecha],
  components: {
    ValidaContratosAcciones,
    NuevoParte
  },
  data() {
    return {
      stepper: 1,
      maxSteps: 4,
      buscarAcciones: "",
      accionesSeleccionadas: [],
      partesDisponibles: [],
      parteSeleccionado: [],
      loadingPartes: false,
      ctrl: false,
      buscarPartes: "",
      resumenAcciones: [],
      loadingConfirmar: false,
    };
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    acciones: {
      type: Array,
      required: true,
    },
    headersPartes: Array,
    parteId: {
      type: Number,
      required: true,
    },
    usuarios: {
      type: Array,
      required: true
    },
    clientes: {
      type: Array,
      required: true
    }
  },
  methods: {
    // ...mapActions({
    //   getContratosDisponibles: "contratos/getContratosDisponibles",
    // }),
    ...mapActions(["setLoading", "setSnackbar"]),
    reset() {
      this.stepper = 1;
      this.$store.dispatch("moverAcciones/reset");
      this.buscarAcciones = "";
      this.accionesSeleccionadas = [];
      this.partesDisponibles = [];
      this.parteSeleccionado = [];
      this.loadingPartes = false;
      this.resumenAcciones = [];
    },
    cerrar() {
      this.reset();
      this.$emit("input", false);
    },
    incrementarStepper() {
      if (this.stepper < this.maxSteps) this.stepper++;
      switch (this.stepper) {
        case 2:
          this.cargarPartes();
          break;
        case 3:
          if (this.isValid) this.incrementarStepper();
          break;
        case 4:
          this.prepararResumenAcciones();
          break;
        default:
          break;
      }
    },
    decrementarStepper() {
      if (this.stepper > 1) this.stepper--;
      switch (this.stepper) {
        case 1:
          this.parteSeleccionado = [];
          this.$store.dispatch("moverAcciones/setAccionesNoValidas", {
            acciones: [],
          });
          break;
        case 2:
          this.validarAcciones();
          this.$store.dispatch("moverAcciones/setAccionesEditadas", {
            acciones: [],
          });
          break;

        default:
          break;
      }
    },

    confirmar() {
      this.loadingConfirmar = true;
      axios
        .patch(`/api/moverAcciones/${this.parteSeleccionado[0].id}`, {
          acciones: this.resumenAcciones,
        })
        .then((respuesta) => {
          this.$emit("actualizarAcciones", this.resumenAcciones);
          this.cerrar();

          this.setSnackbar({
            snackbar: true,
            tipo: "success",
            mensaje: "Se han movido las acciones correctamente!",
          });
        })
        .catch((error) => {
          this.setSnackbar({
            snackbar: true,
            tipo: "error",
            mensaje: "Error. No se han podido mover las acciones",
          });
        })
        .finally(() => {
          this.loadingConfirmar = false;
        });
    },
    cargarPartes(forzarRecarga = false) {
      console.log("Entrando en recargar partes");
      if (!this.partesDisponibles.length || this.ctrl || forzarRecarga) {
        this.partesDisponibles = [];
        this.loadingPartes = true;
        const params = {
          cliente: null,
          idsEstadosParteSeleccionados: [1,2,3],
        };

        axios
          .get("/api/partes", { params })
          .then((res) => {
            this.partesDisponibles = res.data;
          })
          .catch((err) => {
            this.setSnackbar({
              snackbar: true,
              tipo: "error",
              mensaje: "Error. No se han podido recuperar los partes",
            });
          })
          .finally(() => {
            this.ctrl = false;
            this.loadingPartes = false;
          });
      }
    },
    validarContratos(event) {
      if (event.value) this.parteSeleccionado[0] = event.item;
      else this.parteSeleccionado = [];
      if (this.parteSeleccionado.length) {
        this.loadingPartes = true;
        this.$store
          .dispatch("moverAcciones/getContratosValidos", {
            cliente: this.parteSeleccionado[0].cliente_id,
            parte: this.parteSeleccionado[0].id,
            tipoParte_id: this.parteSeleccionado[0].tipoParte_id,
          })
          .then(() => {
            this.validarAcciones();
          })
          .finally(() => {
            this.loadingPartes = false;
          });
      } else
        this.$store.dispatch("moverAcciones/setContratosValidos", {
          contratos: [],
        });
    },
    validarAcciones() {
      this.$store.dispatch("moverAcciones/setAccionesNoValidas", {
        acciones: this.accionesSeleccionadas,
      });
    },
    prepararResumenAcciones() {
      this.resumenAcciones = this.accionesSeleccionadas.filter(
        ({ id: id1 }) =>
          !this.accionesNoValidas.some(({ id: id2 }) => id2 === id1)
      );
      this.resumenAcciones.push(...this.accionesEditadas);
    },
  },
  computed: {
    ...mapGetters({
      headerAcciones: "acciones/headers",
      isValid: "moverAcciones/isValid",
      accionesNoValidas: "moverAcciones/accionesNoValidas",
      accionesEditadas: "moverAcciones/accionesEditadas",
      loading: "moverAcciones/loadingValidacion"
    }),
  }
};
</script>

<style>
</style>